import { helpers, required, requiredIf, email, numeric, minLength, maxLength } from "@vuelidate/validators";
import {cprValidation, worksetValidation, dateStartEndValidation, phoneDummyValidation} from "./customValidators";
// DISABLED BY AGREEMENT WITH FTFa - 2024-03-06
// import {cprValidation, worksetValidation, dateValidation, dateStartEndValidation, phoneDummyValidation} from "./customValidators";




const forbiddenCharsAndNumbers = (value) => {
  if (!value) return true; // DON'T THROW ERRORS ON EMPTY VALUES - OTHER VALIDATORS HANDLE THAT
  
  const regex = /[{}[\]()!#%"*§¤?<>+/0-9]/; // REGULAR EXPRESSIONS WITH DISALLOWED CHARACTERS
  return !regex.test(value);
};

const forbiddenChars = (value) => {
  if (!value) return true; // DON'T THROW ERRORS ON EMPTY VALUES - OTHER VALIDATORS HANDLE THAT
  
  const regex = /[{}[\]()!#%"*§¤?<>+-/]/; // REGULAR EXPRESSIONS WITH DISALLOWED CHARACTERS
  return !regex.test(value);
};

export function validations(store) {

  return {
    workPlaceDetails: {
      values: {
        companyName: {
          required: requiredIf(store.subscriptionType === "employed")
        },
        companyAddress: {
          forbiddenChars: helpers.withMessage("Not allowed", forbiddenChars),
        },
        unemployedWorkArea: {
          worksetValidationArea: helpers.withMessage("unemployedWorkArea", () => {
            return worksetValidation(store[store.currentCulture].values.personalDetails.workSets, "area");
          }),
        },
        unemployedWorkFunction: {
          worksetValidationFunction: helpers.withMessage("unemployedWorkFunction", () => {
            return worksetValidation(store[store.currentCulture].values.personalDetails.workSets, "function");
          }),
        },
        workAreas: {
          worksetValidationArea: helpers.withMessage("workAreas", () => {
            return worksetValidation(store[store.currentCulture].values.personalDetails.workSets, "area");
          }),
        },
        workFunctions: {
          worksetValidationFunction: helpers.withMessage("workFunctions", () => {
            return worksetValidation(store[store.currentCulture].values.personalDetails.workSets, "function");
          }),
        },
        payByCompany: required
      }
    },
    personalDetails: {
      values: {
        firstname: {
          required,
          forbiddenCharsAndNumbers: helpers.withMessage("Not allowed", forbiddenCharsAndNumbers),
        },
        lastname: {
          required,
          forbiddenCharsAndNumbers: helpers.withMessage("Not allowed", forbiddenCharsAndNumbers),
        },
        cpr: {
          required: requiredIf(() => !store[store.currentCulture].values.personalDetails.nocpr),
          cprValidation: helpers.withMessage("custom validation message", value => {
            // Don't validate if nocpr is true
            // if (store[store.currentCulture].values.personalDetails.nocpr) return true;
            return cprValidation(value);
          }),
        },
        country:{
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.nocpr),
        },
        gender:{
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.nocpr),
        },
        birthday:{
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.nocpr),
        },
        emailaddress: {
          required,
          email
        },
        phonearea: {
          required,
          numeric,
          minLength: minLength(2),
          maxLength: maxLength(3)
        },
        phone: {
          required,
          numeric,
          phoneDummyValidation: helpers.withMessage("Not allowed", phoneDummyValidation),
          minLength: minLength(6),
          maxLength: maxLength(12)
        },
      }
    },
    educationDetails: {
      values: {
        educationLevel: {
          required: requiredIf(() => !store[store.currentCulture].values.personalDetails.isEducation && !store[store.currentCulture].values.personalDetails.isTrainee),
        },
        yourEducation: requiredIf(store.subscriptionType === "student" || store.dimStudent === "ja"),
        educationType: {
          required: requiredIf(store.subscriptionType === "student" || store.dimStudent === "ja")
        },
        educationInstitution: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isEducation || store.dimStudent === "ja"),
        },
        educationCurrent: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isEducation || store.dimStudent === "ja"),
        },
        educationStarted: { 
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isEducation || store.dimStudent === "ja"),
        },
        educationExpectedEnd: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isEducation),
          /* DISABLED BY AGREEMENT WITH FTFa - 2024-03-06
          dateValidation: helpers.withMessage('date-validation-message', value => {
            if(!store[store.currentCulture].values.personalDetails.isEducation) return true;
  
            var dateStart = store[store.currentCulture].values.personalDetails.educationStarted;
            var dateEnd = store[store.currentCulture].values.personalDetails.educationExpectedEnd;
  
            var personalDetails = store[store.currentCulture].values.personalDetails;
            var visualDetails = store[store.currentCulture].values.visualDetails;
            var productDetails = store[store.currentCulture].values.productDetails;
  
            return dateValidation(value, dateStart, dateEnd, personalDetails, visualDetails, productDetails);
          }),
          */
          dateStartEndValidation: helpers.withMessage("date-validation-message", value => {
            if(!store[store.currentCulture].values.personalDetails.isEducation) return true;
            if(!store[store.currentCulture].values.personalDetails.isEducation && store[store.currentCulture].values.personalDetails.dimStudent != "ja") return true;
  
            var dateStart = store[store.currentCulture].values.personalDetails.educationStarted;
            var dateEnd = store[store.currentCulture].values.personalDetails.educationExpectedEnd;
  
            return dateStartEndValidation(value, dateStart, dateEnd);
          }),
        },
        traineeCompanyName: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isTrainee),
        },
        traineeWorkAreas: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isTrainee),
        },
        traineeWorkFunctions: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isTrainee),
        },
        traineeStarted: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isTrainee),
        },
        traineeExpectedEnd: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.isTrainee),
          dateStartEndValidation: helpers.withMessage("date-validation-message", value => {
            if(!store[store.currentCulture].values.personalDetails.isTrainee) return true;
  
            var dateStart = store[store.currentCulture].values.personalDetails.traineeStarted;
            var dateEnd = store[store.currentCulture].values.personalDetails.traineeExpectedEnd;
  
            return dateStartEndValidation(value, dateStart, dateEnd);
          }),
        },
      },
    },
    languageDetails: {
      values: {
        informationLanguage: requiredIf(store.currentCulture === "en")
      }
    },
    unionDetails: {
      values: {
        unionmember: { required },
        unionunsubscribe:{
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.unionmember === "ja"),
        },
        unionwhichone: {
          required : requiredIf(() => store[store.currentCulture].values.personalDetails.unionunsubscribe === "ja")
        }
      }
    },
    insuranceDetails:{
      values: {
        homeInsurance: {
          required
        }
      }
    },
    dimStudent: {
      values: {
        dimStudent: { // hvis akasse ikke er ftfa
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.unemploymentinsurance !== "Ftfa"),
        },
        dimStudentYesno: { // hvis der er svaret ja til at være dimittend og man er studerende
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimStudent === "ja" && store.subscriptionType === "student")
        },
        dimRightsNO: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimRights === "nej")
        },
        dimStudentFree: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimStudentYesno === "nej" && store.subscriptionType === "student")
        },
        dimStudentSu: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimStudentFree === "ja" && store.subscriptionType === "student")
        },
        dimStudentPension: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimStudentFree === "ja" && store.subscriptionType === "student")
        },
        dimStudentInDenmark: {
          required: requiredIf(() => store[store.currentCulture].values.personalDetails.dimStudentYesno === "nej")
        },
        dimRights: {
          required: requiredIf(() => store.subscriptionType === "student"),
        }
      }
    }
  };
}